@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';

$text-field-lock-bottom: 0.5rem;

.textContainer {
  @include barlow(16);
  width: 100%;

  .noLabel {
    margin-top: 0;
  }

  .hasLabel {
    margin-top: 0.125rem;
  }

  .hasLabel .text {
    margin-top: 0.3125rem;
  }

  .label {
    color: _palette(text-secondary);
    display: block;

    .required {
      color: _palette(text-red);
      font-weight: 600;
    }
  }

  .text {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(black-25);
    border-radius: 5px;
    display: block;
    height: 2.5rem;
    outline: none;
    padding: 0.625rem 1.6rem 0.625rem 0.75rem;
    width: 100%;
    position: relative;

    .lock {
      bottom: $text-field-lock-bottom;
      height: 1.5rem;
      pointer-events: none;
      position: absolute;
      right: 0.5rem;
      width: 1.5rem;
    }

    .stopOverflow {
      display: block;
      line-height: 1.125rem;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: center;
      white-space: nowrap;
    }
  }
}
